import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, CreditCard } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const benefits = ['El Sistema Mamá IA (El mapa paso a paso)', 'Biblioteca de Prompts Maestros (Para que la IA trabaje por ti)', 'Guía de Visuales Faceless (Para vender sin mostrar tu cara)'];
const paymentMethods = ['Visa', 'Mastercard', 'Amex', 'PayPal'];
export function ValueStack() {
  const handleCTAClick = () => {
    trackAddToCart();
    window.open('https://www.vitarutinas.com/cart/50347583471862:1', '_blank');
  };
  return <section id="oferta" className="py-16 px-4 bg-white" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        {/* Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-primary text-white text-center py-3 rounded-t-lg font-bold text-lg" data-id="element-204">
          OFERTA ESPECIAL DE LANZAMIENTO
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-gray-50 p-8 rounded-b-lg shadow-xl border-2 border-primary" data-id="element-205">
          {/* Title */}
          <h2 className="font-serif text-3xl md:text-4xl text-dark text-center mb-2" data-id="element-206">
            Sistema Mamá IA
          </h2>
          <p className="text-body text-center mb-8" data-id="element-207">
            La tecnología más simple para crear tu primer producto digital
          </p>

          {/* Benefits */}
          <div className="space-y-4 mb-8" data-id="element-208">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2 + index * 0.1
          }} className="flex items-start gap-3" data-id="element-209">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-210" />
                <p className="text-dark text-lg" data-id="element-211">{benefit}</p>
              </motion.div>)}
          </div>

          {/* Pricing */}
          <div className="text-center mb-8" data-id="element-212">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-213">
              <span className="text-2xl text-body line-through" data-id="element-214">$299</span>
              <span className="text-5xl font-bold text-primary" data-id="element-215">$110</span>
              <span className="text-lg text-body" data-id="element-216">MXN</span>
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full font-semibold text-sm mb-4" data-id="element-217">
              93% OFF
            </div>
            <p className="text-body font-medium" data-id="element-218">
              Pago único · Sin suscripciones
            </p>
          </div>

          {/* CTA Button */}
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} onClick={handleCTAClick} className="shimmer-cta pulse-glow w-full py-4 rounded-lg text-white font-bold text-lg mb-6" data-id="element-219">
            OBTENER ACCESO AHORA →
          </motion.button>

          {/* Payment Methods */}
          <div className="text-center" data-id="element-220">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-221">
              <CreditCard className="w-5 h-5 text-body" data-id="element-222" />
              {paymentMethods.map((method, index) => <span key={index} className="text-sm text-body font-medium" data-id="element-223">
                  {method}
                </span>)}
            </div>
            <p className="text-sm text-body font-medium" data-id="element-224">🔒 Pago 100% Seguro</p>
          </div>
        </motion.div>
      </div>
    </section>;
}